<template>
  <div class="my-order">
    <el-menu
      :default-active="currentMenu"
      class="el-menu-demo"
      mode="horizontal"
      background-color="#fff"
      text-color="#333333"
      active-text-color="#2782EC"
      @select="handleSelect"
    >
      <el-menu-item index="0">
        <el-badge
          v-if="countOrderData.approveCount"
          :value="countOrderData.approveCount"
          :max="99"
          class="item"
        >
          待审批
        </el-badge>
        <span v-else>待审批</span>
      </el-menu-item>
      <el-menu-item index="2">
        <el-badge
          v-if="approvedTotal"
          :value="approvedTotal"
          :max="99"
          class="item"
        >
          已审批
        </el-badge>
        <span v-else>已审批</span>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
export default {
  props: {
    countOrder: {
      type: Object,
      default: () => {
        return {
          allCount: 0,
          approveCount: 0,
        };
      },
    },
    approvedTotal: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      currentMenu: '0',
      countOrderData: {
        allCount: 0,
        approveCount: 0,
      },
    };
  },
  watch: {
    countOrder: {
      deep: true,
      handler(newval) {
        this.countOrderData = newval;
      },
    },
  },
  methods: {
    handleSelect(key, keyPath) {
      this.currentMenu = key;
      this.$emit('setCurrentMenu', key);
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/css/theme.scss';
.my-order {
  width: 165px;
  ul {
    li {
      border-bottom-color: $border-color !important;
    }
  }
  .tip {
    height: 48px;
    background: #fffcec;
    color: #2587ff;
    margin-bottom: 10px;
    padding-left: 10px;
    display: flex;
    align-items: center;
    .to-old {
      display: inline-block;
      margin: 0 6px;
      border-bottom: 1px solid #2587ff;
      cursor: pointer;
    }
    img {
      width: 18px;
      margin-right: 10px;
    }
  }
  ::v-deep.el-menu--horizontal > .el-menu-item {
    height: 48px;
    line-height: 46px;
    width: 82px;
    text-align: center;
    border-right: 1px solid $border-color;
    border-bottom: 1px solid $border-color;
    border-top: 2px solid transparent;
    &:last-child {
      width: 82px;
    }
  }
  ::v-deep .el-menu--horizontal {
    border-bottom: none;
  }

  ::v-deep .el-menu--horizontal > .el-menu-item:hover {
    background: #f4f7ff !important;
  }

  ::v-deep .el-menu--horizontal > .is-active {
    background: #f4f7ff !important;
    border-top: 2px solid #2587ff;
    border-bottom: none;
  }

  ::v-deep .el-menu-demo {
    border-top: 1px solid $border-color;
    border-right: 1px solid $border-color;
    border-left: 1px solid $border-color;
    display: flex;
  }
  ::v-deep.el-badge__content {
    line-height: 15px;
    border-color: #f56c6c;
  }

  ::v-deep .el-badge__content.is-fixed {
    top: 8px;
    right: 0;
  }
}
</style>
